import React, { useCallback, useState }  from 'react';
import { useDispatch, useSelector } from 'react-redux'

// Components
import AjaxController from '../system/ajaxController';

// Redux slices
import { setActivePage, setUser, setToken, setContractId } from '../../appSlice';
import { updateObjectData } from './objectSlice';

// SystemData
import { optionsSeason } from '../contract/systemdata';


/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// SemanticUI components
import { CardMeta, CardHeader, CardGroup, CardContent, Card, Image, Container, Grid, GridRow, GridColumn, Label, Button, Modal, Header, Icon, HeaderContent, Segment, Form, FormSelect } from 'semantic-ui-react'

// Styles
import './object.css';


registerLocale('de', de);
setDefaultLocale('de');



/**
 * 
 * @returns 
 */
const Max2Contracts = () => {
  // local State
  const [expandList, setExpandList] = useState(false);
  const [showSeasonModal, setShowSeasonModal] = useState(false);
  const [selectedSeason, setSelectedSeason] = useState(false);

  // global State
  const dispatch = useDispatch();
  const editMode    = useSelector((state) => state.object.sections.Texts.edit)
  const object      = useSelector((state) => state.object.data);
  const objectID    = useSelector((state) => state.app.objectId);
  const backendUrl  = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();


  /**
   * 
   * @param {integer} oid 
   */
  const handleOpenContractClick = (cid) => {
    dispatch(setActivePage('CONTRACT'));
    dispatch(setContractId(cid));
  }


  const handleCreateNewContractClick = useCallback(async () => {
    if (!selectedSeason) {
      enqueueSnackbar('Kein Saison ausgewählt', { variant: 'error' });
      return;
    }

    // Check if backendUrl is defined
    if (!backendUrl) {
      enqueueSnackbar('Backend URL is not defined', { variant: 'error' });
      return;
    }

    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    // collect data
    const data = {
      'Season': selectedSeason,
      'Destination': object.Transfers[0]?.DestinationAirport,
      'Address': object.Address,
      'Basics': object.Basics,
      'Product': object.Product
    }

    // send create pdf request
    let response;
    try {
      response = await api.post('/contract/new', data);
    } catch (error) {
      console.error('Error creating new contract:', error);
      enqueueSnackbar('Fehler beim Erstellen des neuen Vertrages. Bitte versuchen Sie es später erneut.', { variant: 'error' });
      return;
    }
    console.log('response', response)

    // refresh contracts list
    let responseContracts;
    try {
      responseContracts = await api.get('/hotel/'+objectID+'/contracts');
      if (typeof responseContracts.Contracts !== 'undefined' || !responseContracts.Contracts.length) {
        dispatch(updateObjectData({section: 'Contracts', value: responseContracts.Contracts}))
      } else {
        console.error('Error loading contracts for current object');
        enqueueSnackbar('Fehler beim Laden der Verträge. Bitte versuchen Sie es später erneut.', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error loading contracts for current object:', error);
      enqueueSnackbar('Fehler beim Laden der Verträge. Bitte versuchen Sie es später erneut.', { variant: 'error' });
      return;
    }
    console.log('responseContracts', responseContracts)

    // Hide modal dialog
    //setShowSeasonModal(false);

  }, [backendUrl, object, objectID, selectedSeason, dispatch, enqueueSnackbar]);




  // filter season options 
  let filteredOptionsSeason = [];
  optionsSeason.forEach(season => {
    let found = false;
    object?.Contracts.forEach(contract => {
      if (contract?.SeasonId === season.value) {
        found = true;
      }
    });
    if (!found) {
      filteredOptionsSeason.push(season);
    }
  });

  // Build contract items
  const cards = object?.Contracts?.map((contract, index) => {
    let statusColor;
    let statusText;
    switch (contract.Meta.Status) {
      case 1: statusColor = 'green'; statusText = 'In Bearbeitung'; break;
      case 3: statusColor = 'orange'; statusText = 'Freigegeben'; break;
      default:  statusColor = 'grey'; statusText = 'Neu angelegt';  break;
    }

    if (!expandList && index > 4) {
      return <></>;
    }

    // Format dates
    const fdateStart = format(new Date(contract?.Period?.Start), 'dd.MM.yyyy')
    const fdateEnd = format(new Date(contract?.Period?.End), 'dd.MM.yyyy')
    const fdateAt = contract?.Meta?.HistoryAt 
      ? format(new Date(contract?.Meta?.HistoryAt), 'dd.MM.yyyy, HH:mm') + ' Uhr'
      : contract?.Meta?.ChangedAt ? format(new Date(contract?.Meta?.ChangedAt), 'dd.MM.yyyy, HH:mm') + ' Uhr' : '';
    const changedBy = contract?.Meta?.HistoryBy ? contract?.Meta?.HistoryByName : contract?.Meta?.ChangedBy;
    const changedText = contract?.Meta?.HistoryChange ? ', ' + contract?.Meta?.HistoryChange : '';

    return (
      <Card fluid color={statusColor} key={index} style={{ maxWidth: '399px' }} onClick={() => handleOpenContractClick(contract.ContractId)}>
        <CardContent style={{background: '#f5f5f5'}}>
          {contract.lock && (<Image floated='right' size='mini' src='resources/icons/locked-padlock.png' title={contract.lock.user + ' - ' + contract.lock.time} style={{width: '20px', margin: '0px'}} />)}
          <CardHeader style={{float: 'left'}}>{contract.SeasonId}</CardHeader>
          <CardMeta style={{float: 'left', marginTop: '-3px', marginLeft: '10px'}}>{contract.Hotelcode}</CardMeta>
          {contract.IsSubContract && (<CardMeta style={{float: 'left', marginTop: '-3px', marginLeft: '10px'}}>Teilkontingent-Vertrag</CardMeta>)}
          <Grid style={{clear: 'both'}}>
              <GridRow className='media_ro_row'>
                <GridColumn width={4} className='media_ro_label' textAlign='right'>Status:</GridColumn>
                <GridColumn width={12}><Label circular size='tiny' color={statusColor}>&nbsp;{statusText}&nbsp;</Label></GridColumn>
              </GridRow>
              <GridRow className='media_ro_row'>
                <GridColumn width={4} className='media_ro_label' textAlign='right'>Laufzeit:</GridColumn>
                <GridColumn width={12}>{fdateStart} - {fdateEnd}</GridColumn>
              </GridRow>
              <GridRow className='media_ro_row'>
                <GridColumn width={4} className='media_ro_label' textAlign='right'>Änderung:</GridColumn>
                <GridColumn width={12} title={contract.Meta.Changed}>{fdateAt}, {changedBy}{changedText}</GridColumn>
              </GridRow>
            </Grid>
        </CardContent>
      </Card>
    );
  });

  // build list
  return (
    <>
    {/* Modal für Saisonauswahl */}
    <Modal
      open={showSeasonModal}
      onClose={() => setShowSeasonModal(false)}
      size='medium'
    >
      <Header icon='exclamation triangle' content='Saisonauswahl' />
      <Modal.Content>
        <Segment>
          <Header>Bitte eine Saison für den neuen Vertrag wählen:</Header>
          <Form>
            <FormSelect fluid search selection label='Saisonbereich' value={selectedSeason} options={filteredOptionsSeason} placeholder='Saisonbereich' onChange={(e, data) => setSelectedSeason(data.value)} />
          </Form>
          <br />

        </Segment>
      </Modal.Content>
      <Modal.Actions>
        <Button basic circular onClick={() => setShowSeasonModal(false)}>abbrechen</Button>
        <Button primary circular onClick={() => handleCreateNewContractClick()}>Vertrag anlegen</Button>
      </Modal.Actions>
    </Modal>

    {/* Vertragsliste */}
    <Container style={{width: '99%'}} textAlign='center'>
      {(!object?.Contracts || !object?.Contracts.length) 
        ? 
        <>
        <Header as='h4' textAlign='center'>
          <Icon name='times circle outline' />
          <HeaderContent>Keine Einträge vorhanden</HeaderContent>
        </Header>
        <br />
        </>
        : 
          <>
          <CardGroup>
            {cards}
          </CardGroup>
          <br />
          {!expandList && object?.Contracts.length > 5 && (<Button basic circular onClick={()=>setExpandList(true)}>mehr ...</Button>)}
          {expandList && (<Button basic circular onClick={()=>setExpandList(false)}>weniger ...</Button>)}
          </>
      }
      {editMode && <><Button primary circular floated='right' onClick={()=>setShowSeasonModal(true)}>Neuen Vertrag anlegen</Button><br /><br /></>}
    </Container>
    </>
  );
}

export default  Max2Contracts;
